import type { Action } from 'src/types';

import type { AnalyticsCurrentPageSectionState } from '../types';

export enum Actions {
  YEARS_OF_EXPERIENCE_EDIT_LOADED = 'YEARS_OF_EXPERIENCE_EDIT_LOADED',
  YEARS_OF_EXPERIENCE_UPDATE = 'YEARS_OF_EXPERIENCE_UPDATE',
}

export type YearsOfExperienceAction =
  | (Action<Actions.YEARS_OF_EXPERIENCE_EDIT_LOADED> & {
      payload: {
        currentPageSectionState: AnalyticsCurrentPageSectionState;
      };
    })
  | (Action<Actions.YEARS_OF_EXPERIENCE_UPDATE> & {
      payload: {
        actionName: 'ADD' | 'EDIT';
        userIsNewToWorkforce: boolean;
      };
    });

export const yearsOfExperienceEditClicked = ({
  currentPageSectionState,
}: {
  currentPageSectionState: AnalyticsCurrentPageSectionState;
}): YearsOfExperienceAction => ({
  type: Actions.YEARS_OF_EXPERIENCE_EDIT_LOADED,
  payload: {
    currentPageSectionState,
  },
});

export const yearsOfExperienceUpdate = ({
  actionName,
  userIsNewToWorkforce,
}: {
  actionName: 'ADD' | 'EDIT';
  userIsNewToWorkforce: boolean;
}): YearsOfExperienceAction => ({
  type: Actions.YEARS_OF_EXPERIENCE_UPDATE,
  payload: {
    actionName,
    userIsNewToWorkforce,
  },
});
